export const formValues = {
  Title: 'Isla hoppia',
  Details: 'Próximamente',
  Map: 'https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg',
}